import { ArrowUpRight } from "lucide-react";
import { products } from "../data/siteContent";
import useReveal from "../hooks/useReveal";

function ProductCard({ item, index }) {
  const ref = useReveal();
  return (
    <article
      ref={ref}
      data-testid={`product-card-${item.id}`}
      className="group reveal bg-white border border-brand-greyBorder hover:border-brand-red transition-colors duration-300"
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-brand-grey">
        <img
          src={item.image}
          alt={item.title}
          className="card-img w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      <div className="p-7 md:p-8">
        <h3 className="font-serif text-2xl md:text-3xl text-brand-charcoal mb-3 group-hover:text-brand-red transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-neutral-600 leading-relaxed mb-6">
          {item.description}
        </p>
        <div className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-brand-charcoal group-hover:text-brand-red">
          Μάθετε περισσότερα
          <ArrowUpRight
            size={16}
            className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
          />
        </div>
      </div>
    </article>
  );
}

export default function Products() {
  return (
    <section
      id="products"
      data-testid="products-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <p className="text-xs tracking-[0.35em] uppercase text-brand-red mb-5 font-medium">
            <span className="inline-block w-10 h-px bg-brand-red align-middle mr-4" />
            {products.eyebrow}
          </p>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl text-brand-charcoal leading-[1.1] tracking-tight mb-6">
            {products.title}
          </h2>
          <p className="text-base md:text-lg text-neutral-600 leading-relaxed max-w-2xl">
            {products.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {products.items.map((item, i) => (
            <ProductCard key={item.id} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
